import * as React from 'react';
import FirestoreConsumer from './FirestoreConsumer';

type Omit<T, K> = Pick<T, Exclude<keyof T, K>>;
type Subtract<T, K> = Omit<T, keyof K>;

type WithFirestoreProps = {
  firestore: firebase.firestore.Firestore;
};

const withFirestore = <WrappedProps extends WithFirestoreProps>(
  WrappedComponent: React.ComponentType<WrappedProps>,
) => (props: Subtract<WrappedProps, WithFirestoreProps>) => {
  return (
    <FirestoreConsumer>
      {({ firestore }) => <WrappedComponent firestore={firestore} {...(props as any)} />}
    </FirestoreConsumer>
  );
};

export default withFirestore;
